
namespace Gamification.Gamification {
    export class UtentiProdottiEsperienzeDashboardColumns {
        static columnsKey = 'Gamification.UtentiProdottiEsperienzeDashboard';
    }
}